import { decodeGrid } from "../data";

export default function Decode() {
  return (
    <section id="decode" className="border-y border-background-200/70 bg-background-100 py-14 md:py-20">
      <div className="wrap">
        {/* 大标题海报感 */}
        <div className="grid items-end gap-6 lg:grid-cols-[1fr_auto]">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
              <span className="font-poster">02</span>
              <span className="h-3 w-px bg-current opacity-40" />
              <span>密码拆解</span>
            </div>
            <h2 className="eyebrow mt-4 text-3xl font-black text-foreground-950 md:text-4xl">
              91，这个数字是<em className="text-primary-600 not-italic">怎么来的</em>
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              把「91」拆开看，会得到几种说法。数字梗好玩的地方就在于：它没有一个官方答案，
              每种读法都对应一种使用它的心情。
            </p>
          </div>

          <div className="hidden items-end gap-1 font-poster text-6xl leading-none text-accent-500 lg:flex">
            <span>9</span>
            <span className="text-primary-500">1</span>
          </div>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-3">
          {decodeGrid.map((it, idx) => (
            <article
              key={it.title}
              className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <span className="absolute right-4 top-3 font-poster text-4xl text-background-200 transition-colors group-hover:text-primary-200">
                0{idx + 1}
              </span>
              <span className="relative inline-flex items-center gap-1 rounded-md bg-accent-100 px-2 py-0.5 text-xs font-semibold text-accent-700">
                <i className="ri-key-2-line h-3.5 w-3.5 flex items-center justify-center" />
                {it.badge}
              </span>
              <h3 className="eyebrow relative mt-4 text-lg font-bold text-foreground-950">{it.title}</h3>
              <p className="relative mt-2 text-sm leading-relaxed text-foreground-600">{it.summary}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}